import { render, staticRenderFns } from "./GalleryEditCard.vue?vue&type=template&id=12bc4344&scoped=true&"
import script from "./GalleryEditCard.vue?vue&type=script&lang=js&"
export * from "./GalleryEditCard.vue?vue&type=script&lang=js&"
import style0 from "./GalleryEditCard.vue?vue&type=style&index=0&id=12bc4344&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bc4344",
  null
  
)

export default component.exports